import { axios } from '../../plugins/axios'
import { handleError } from '../../plugins/errors'

export const handleLogin = async ({ state, commit }) => {
  try {
    const { data } = await axios.post('/api/auth/login')
    commit('SET_USER', data)
    // console.log(data)
  } catch (e) {
    handleError(e, this)
  }
}

export const sendForgotEmail = async ({ dispatch, commit, getters, rootGetters }, { client, email }) => {
  try {
    const response = await client.post('/api/auth/recovery', { email: email })
    const { data } = response
    // console.log(response)
    if (data && data.error) {
      commit('SET_LOGIN_KEY', {
        key: 'requiresEmail',
        value: true
      })
      return false
    } else {
      commit('SET_AUTH', data)
      return true
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const resetPassword = async ({ dispatch, commit, getters, rootGetters }, { client, resetToken, password, passwordConfirmation, email }) => {
  try {
    const { data } = await client.post('/api/auth/reset', {
      token: resetToken,
      email: email,
      password: password,
      password_confirmation: passwordConfirmation
    })
    commit('SET_AUTH', data)
  } catch (error) {
    throw new Error(error)
  }
}

export const fetchUser = async ({ dispatch, commit, getters, rootGetters }, payload) => {
  try {
    const response = await payload.client.get('/auth/me')
    if (response.status === 200 && response.data) {
      commit('SET_AUTH', response.data)
      return response
    }
    return response
  } catch (error) {
    return error
  }
}

export const refreshUserToken = async ({ dispatch, commit, getters, rootGetters }, payload) => {
  try {
    const { data } = await payload.client.get('/auth/refresh')
    commit('SET_AUTH', data)
  } catch (error) {
    throw new Error(error)
  }
}

export const loginAsUser = async ({ dispatch, commit, getters, rootGetters }, { client, id, email }) => {
  try {
    const { data } = await client.post('/admin/superimpose', {
      id,
      email
    })
    commit('SET_AUTH', data)
  } catch (e) {
    // console.log(e)
  }
}

export const userLogin = async ({ dispatch, commit }, { client, email, password, username }) => {
  try {
    const response = await client.post('/auth/login', {
      email: email,
      username: username,
      password: password
    })
    // console.log(response)
    if (response && response.data) {
      // console.log('login data!')
      // console.log(response.data)
    }
    commit('SET_AUTH', response.data)
  } catch (error) {
    throw new Error(error)
  }
}

export const userLogout = async ({ dispatch, commit }) => {
  try {
    commit('LOGOUT_USER')
  } catch (error) {
    throw new Error(error)
  }
}
